import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import DescountList from './DescountList';
import DescountForm from './DescountForm';
import DeletedDescountsList from './DeletedDescountsList';

const Descounts = () => {
  return (
    <Routes>
      <Route path="/" element={<DescountList />} />
      <Route path="/new" element={<DescountForm />} />
      <Route path="/:id/edit" element={<DescountForm />} />
      <Route path="/deleted" element={<DeletedDescountsList />} />
      <Route path="*" element={<Navigate to="/descounts" replace />} />
    </Routes>
  );
};

export default Descounts;
